import RouteBase from '@/router/routes/RouteBase.js';

class RoutesHorizon {
  subFolderPath = '/businessPartners/horizon';
  isPublic = false;

  Home = new RouteBase({
    name: 'horizon-home',
    path: '',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Home',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {
        isCollapsable: false,
        icon: 'wave',
        title: 'Varta',
        hasBackButton: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Varta',
        },
      ],
    },
  });

  Brand = new RouteBase({
    name: 'brand',
    path: ':brand/:id',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Brand',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Varta',
          link: '/secure/business-partners/varta',
        },
        {
          name: 'Kategori',
        },
      ],
    },
  });

  List = new RouteBase({
    name: 'list',
    path: 'price-list',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'List',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Varta',
          link: '/secure/business-partners/varta',
        },
        {
          name: 'Güncel Fiyat Listesi',
        },
      ],
    },
  });
}

export default new RoutesHorizon();
